export const indexToAlphabet = (index) => {
    if (index < 0 || index > 25) {
        return '_';
    }
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return alphabet[index];
};

export const jumbleWithIndex = (arr) => {
    // Create array of objects with original index
    const withIndex = arr.map((text, index) => ({ text, originalIndex: index }));

    // Shuffle using Fisher-Yates algorithm
    for (let i = withIndex.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [withIndex[i], withIndex[j]] = [withIndex[j], withIndex[i]];
    }

    return withIndex;
};
